import { injectable } from 'tsyringe'
import { TrainingCategoryApiRepository } from '@/app/repositories/api/TrainingCategoryRepository'
import { TrainingCategory } from '@/domain/entities/TrainingCategory'
import {
  PostTrainingCategoryInterface,
  DeleteTrainingCategoryInterface,
  UpdateTrainingCategoryInterface,
} from '@/data/payload/contracts/TrainingCategoryRequest'
@injectable()
export class TrainingCategoryPresenter {
  private repository: TrainingCategoryApiRepository

  constructor(repository: TrainingCategoryApiRepository) {
    this.repository = repository
  }

  public loadTrainingCategories(params: Object): Promise<TrainingCategory> {
    return this.repository.getAll(params)
  }

  public postTrainingCategories(
    payload: PostTrainingCategoryInterface
  ): Promise<TrainingCategory> {
    return this.repository.post(payload)
  }

  public updateTrainingCategories(
    payload: UpdateTrainingCategoryInterface,
    id: number
  ): Promise<TrainingCategory> {
    return this.repository.update(payload, id)
  }

  public deleteTrainingCategories(
    payload: DeleteTrainingCategoryInterface
  ): Promise<TrainingCategory> {
    return this.repository.delete(payload)
  }
}
